import { color } from '@helpers/constants';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { getFontSize, TypographyProps } from './common';

type Props = TypographyProps & HTMLAttributes<HTMLHeadingElement>;

export default function H4({
    variant = 'Sora',
    size = 'md',
    bold,
    textDecoration,
    m: margin,
    ...props
}: PropsWithChildren<Props>) {
    return (
        <h3
            {...props}
            style={{
                fontFamily: variant,
                fontWeight: bold ? 600 : 400,
                margin,
                color: bold ? color('bold-text') : color('text'),
                fontSize: getFontSize(size, 0.1),
                textDecoration,
            }}
        >
            {props.children}
        </h3>
    );
}
